import React, { useState } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";

const HomePage = () => {
  const [showGpaOptions, setShowGpaOptions] = useState(false); // State for GPA options
  const [showSyllabusOptions, setShowSyllabusOptions] = useState(false); // State for Syllabus options
  const [showExamOptions, setShowExamOptions] = useState(false);
  const navigate = useNavigate(); // Hook for navigation

  const particlesInit = async (main) => {
    console.log(main);
    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };

  return (
    <div className="min-h-[95vh] relative px-4 m-auto items-center flex justify-center">
      <Helmet>
        <title>CGPA CALC</title>
      </Helmet>
      <Particles
        className="absolute"
        style={{ position: "absolute !important" }}
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          particles: {
            number: { value: 50, density: { enable: true, area: 1000 } },
            color: { value: "#E8FFFF" },
            shape: { type: "polygon", polygon: { nb_sides: 6 } },
            opacity: { value: 1 },
            size: { value: 8, random: true, anim: { enable: true, speed: 10 } },
            move: {
              enable: true,
              speed: 8,
              direction: "bottom-right",
              random: true,
              outMode: "out",
            },
          },
          interactivity: { detectsOn: "parent" },
          detectRetina: true,
        }}
      />
      <div className="text-center relative z-10 space-y-4">
        {/* <h1 className="text-2xl font-bold text-white-800">Welcome to CGPA CALC</h1> */}
        <p className="text-lg text-white">
          <br />
          <strong>
            Choose your Regulation to Calculate GPA, CGPA, Hall, Question Paper, 
          </strong>
          <p>
           Results : {" "}
          <a
            href="https://sonasoft.sonatech.ac.in/Studentdashboard/#/"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" , fontWeight: "bold" }}
          >
             Click to See Semester Result
          </a>
        </p>
        {/* <p>
          New Updates : Previous Year Question Paper & Materials.
          </p> */}
        </p>
        <div className="flex flex-col space-y-6 justify-center mt-6">
  {/* GPA Button */}
  {!showGpaOptions && (
    <button
      onClick={() => setShowGpaOptions(true)}
      className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
    >
      GPA
    </button>
  )}

  {/* GPA Options */}
  {showGpaOptions && (
    <div className="flex space-x-4 justify-center">
      <button
        onClick={() => navigate("/gpa")}
        className="bg-transparent border-2 border-white-600 text-white-600 px-4 py-2 rounded-lg shadow-md hover:bg-white-100 transition"
      >
        2019 Regulation
      </button>
      <button
        onClick={() => navigate("/gpa1")}
        className="bg-transparent border-2 border-white-600 text-white-600 px-4 py-2 rounded-lg shadow-md hover:bg-white-100 transition"
      >
        2023 Regulation
      </button>
    </div>
  )}

    {/* 2025 Admitted Students gpa Button */}
  <Link
    to="/gpa2025"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    2025,26 Admitted Batch Students GPA
  </Link>

  {/* CGPA Button */}
  <Link
    to="/cgpa"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    CGPA
  </Link>

    {/* Previous Year Papers Button */}
  <Link
    to="/previous-papers"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    Previous Year QPapers
  </Link>

    <Link
    to="/previous-materials"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    Previous Year Materials
  </Link>

  {/* About Button */}
  <Link
    to="/about"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    About Page
  </Link>

    {/* Hall Button */}
  <Link
    to="/hall"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    Sona Hall Location
  </Link>

    {/* Exam Schedule Button */}
  {!showExamOptions && (
  <button
    onClick={() => setShowExamOptions(true)}
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
   Exam Schedule
  </button>
)}

{showExamOptions && (
  <div className="flex space-x-4 justify-center">
    <button
      onClick={() => navigate("/examschedule/2019")}
      className="bg-transparent border-2 border-white-600 text-white-600 px-4 py-2 rounded-lg shadow-md hover:bg-white-100 transition"
    >
      2019 Regulation
    </button>
    <button
      onClick={() => navigate("/examschedule/2023")}
      className="bg-transparent border-2 border-white-600 text-white-600 px-4 py-2 rounded-lg shadow-md hover:bg-white-100 transition"
    >
      2023 Regulation
    </button>
  </div>
)}

    {/*Academic Schedules*/}
    <Link
    to="/academic"
    className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
  >
    Academic Schedule
  </Link>

        {/* Syllabus Button */}
    {!showSyllabusOptions && (
    <button
      onClick={() => setShowSyllabusOptions(true)}
      className="bg-transparent border-2 border-white-600 text-white-600 px-6 py-3 rounded-lg shadow-md hover:bg-white-100 transition"
    >
      Syllabus
    </button>
  )}

  {/* Syllabus Options */}
  {showSyllabusOptions && (
   <div className="flex space-x-4 justify-center">
      <button
        onClick={() => navigate("/syllabus")}
        className="bg-transparent border-2 border-white-600 text-white-600 px-4 py-2 rounded-lg shadow-md hover:bg-white-100 transition"
      >
        2019 Regulation
      </button>
      <button
        onClick={() => navigate("/syllabus1")}
        className="bg-transparent border-2 border-white-600 text-white-600 px-4 py-2 rounded-lg shadow-md hover:bg-white-100 transition"
      >
        2023 Regulation
      </button>
    </div>
  )}

</div>

      </div>
    </div>
  );
};

export default HomePage;


// import React from "react";
// import Particles from "react-tsparticles";
// import { motion } from "framer-motion";
// import { loadFull } from "tsparticles";
// import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";3
// import React, { useState } from "react"; 

// const HomePage = () => {
//   const [showGpaOptions, setShowGpaOptions] = useState(false);
//   const navigate = useNavigate();

// const HomePage = () => {
//   const icon = {
//     hidden: {
//       opacity: 0,
//       pathLength: 0,
//       fill: "url(#grad)",
//     },
//     visible: {
//       opacity: 1,
//       pathLength: 1,
//       fill: "url(#grad)",
//     },
//   };

//   const particlesInit = async (main) => {
//     console.log(main);
//     await loadFull(main);
//   };

//   const particlesLoaded = (container) => {
//     console.log(container);
//   };

//   return (
//     <div className="min-h-[95vh] relative px-4 m-auto items-center flex justify-center">
//       <Helmet>
//         <title>
//           CGPA CALC
//         </title>
//       </Helmet>
//       <Particles
//         className="absolute"
//         style={{ position: "absolute !important" }}
//         id="tsparticles"
//         init={particlesInit}
//         loaded={particlesLoaded}
//         options={{
//           particles: {
//             number: {
//               value: 50,
//               density: {
//                 enable: true,
//                 area: 1000,
//               },
//             },
//             color: {
//               value: "#E8FFFF",
//             },
//             shape: {
//               type: "polygon",
//               stroke: {
//                 width: 0,
//                 color: "#000000",
//               },
//               polygon: {
//                 nb_sides: 6,
//               },
//             },
//             opacity: {
//               value: 1,
//               random: false,
//               anim: {
//                 enable: false,
//                 speed: 1,
//                 opacity_min: 0.2,
//                 sync: false,
//               },
//             },
//             size: {
//               value: 8,
//               random: true,
//               anim: {
//                 enable: true,
//                 speed: 10,
//                 size_min: 0.1,
//                 sync: false,
//               },
//             },
//             lineLinked: {
//               enable: false,
//               distance: 150,
//               color: "#ffffff",
//               opacity: 0.4,
//               width: 1,
//             },
//             move: {
//               enable: true,
//               speed: 8,
//               direction: "bottom-right",
//               random: true,
//               straight: false,
//               outMode: "out",
//               attract: {
//                 enable: false,
//                 rotateX: 600,
//                 rotateY: 1200,
//               },
//             },
//           },
//           interactivity: {
//             detectsOn: "parent",
//             events: {
//               onHover: {
//                 enable: false,
//                 mode: "repulse",
//               },
//               onClick: {
//                 enable: false,
//                 mode: "push",
//               },
//               resize: true,
//             },
//             modes: {
//               grab: {
//                 distance: 400,
//                 lineLinked: {
//                   opacity: 1,
//                 },
//               },
//               bubble: {
//                 distance: 400,
//                 size: 40,
//                 duration: 2,
//                 opacity: 8,
//                 speed: 3,
//               },
//               repulse: {
//                 distance: 200,
//               },
//               push: {
//                 particles_nb: 4,
//               },
//               remove: {
//                 particles_nb: 2,
//               },
//             },
//           },
//           detectRetina: true,
//         }}
//       />
//       {/* Main Content */}
//       {/* <div className="text-center relative z-10 space-y-4">
//         <h1 className="text-4xl font-bold text-gray-800">
//         </h1>
//         <p className="text-lg text-white">
//           <strong>Choose your regulation to calculate your GPA and CGPA</strong>
//         </p>
//         <div className="flex space-x-4 justify-center mt-6">
//           <Link
//             to="/gpa"
//             className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition"
//           >
//             <strong>2019 Regulation</strong>
//           </Link>
//           <Link
//             to="/gpa1"
//             className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition"
//           >
//             <strong>2023 Regulation</strong>
//           </Link>
//         </div>
//       </div> */}
//        <div className="text-center relative z-10 space-y-4">
//         <h1 className="text-4xl font-bold text-gray-800">Welcome to CGPA Calc</h1>
//         <p className="text-lg text-white">
//           <strong>Navigate to calculate GPA, CGPA, view syllabus, or learn more about us.</strong>
//         </p>
//         <div className="flex flex-col space-y-4 justify-center mt-6">
//           {/* GPA Button */}
//           {!showGpaOptions && (
//             <button
//               onClick={() => setShowGpaOptions(true)}
//               className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition"
//             >
//               GPA
//             </button>
//           )}

//           {/* GPA Options */}
//           {showGpaOptions && (
//             <div className="space-y-4">
//               <button
//                 onClick={() => navigate("/gpa")}
//                 className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-600 transition"
//               >
//                 2019 Regulation
//               </button>
//               <button
//                 onClick={() => navigate("/gpa1")}
//                 className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-600 transition"
//               >
//                 2023 Regulation
//               </button>
//             </div>
//           )}

//           {/* CGPA Button */}
//           <Link
//             to="/cgpa"
//             className="bg-green-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-green-700 transition"
//           >
//             CGPA
//           </Link>
//           {/* Syllabus Button */}
//           <Link
//             to="/syllabus"
//             className="bg-purple-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-purple-700 transition"
//           >
//             Syllabus
//           </Link>
//           {/* About Button */}
//           <Link
//             to="/about"
//             className="bg-yellow-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-yellow-700 transition"
//           >
//             About
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;

